import { app } from '../../../../app';
import { Controller } from './manage-account.controller';

app.component('companyUserDirectoriesManageAccount', {
    bindings: {account: '<'},
    controller: Controller,
    templateUrl: require('./manage-account.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-account/manage-account.component.js